import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer } from 'redux-recompose';

import { actions } from './actions';
import { TARGETS } from './constants';

const initialState = {
  [TARGETS.SIGNED_URL]: null,
  [TARGETS.UPLOAD_FILE]: null
};

const completedState = completeState(initialState);

const reducerDescription = {
  primaryActions: [actions.GET_SIGNED_URL, actions.UPLOAD_FILE]
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
